// extracted by mini-css-extract-plugin
var _1 = "DocFlowPhaseTable-moduleDocFlowPhaseTable__VISG7";
var _2 = "DocFlowPhaseTable-modulecontrolBar__mTX8Z TableControlBar-moduleTableControlBar__oSO8o";
var _3 = "DocFlowPhaseTable-modulepagination__dqzQr TablePagination-moduleTablePagination__cupJ7";
var _4 = "DocFlowPhaseTable-moduletableFilters__mlGzq FilterBar-modulefilterBar__ifWmS";
var _5 = "DocFlowPhaseTable-moduletableWrapper__I6F03";
export { _1 as "DocFlowPhaseTable", _2 as "controlBar", _3 as "pagination", _4 as "tableFilters", _5 as "tableWrapper" }
